import { userRoles } from './user-labels.js';

const store = {
    namespaced: true,
    state: {
        userId: null,
        userName: null,
        email: null,
        isApproved: null,
        firstName: null,
        lastName: null,
        title: null,
        extension: null,
        roles: [],
        ready: false,
        isExternalUser: null,
        frontLinePX: false
    },
    getters: {
        userReady: state => {
            return state.ready;
        }
    },
    actions: {
        async create({commit}, data) {
            commit("setReady", false);
            console.log("x-user create user: ", data);
            await romeApi.post(`/user`, data.user);
            commit("setReady", true);
        },
        async update({commit, dispatch, state}, data) {
            commit("setReady", false);
            console.log("x-user update user: ", data);
            await romeApi.post(`/user/${data.user.userId}`, data.user);
            let user = Object.assign({}, state, data.user);
            dispatch("users/update", user, {root:true});
            commit("setReady", true);
        },
        async activation({commit, dispatch, state}, data) {
            await romeApi.post(`/user/${data.userId}/${data.isApproved ? 'activate' : 'deactivate'}`);
            let user = Object.assign({}, state, {isApproved: data.isApproved});
            dispatch("users/update", user, {root:true});
        },
        async load({commit}, data) {
            commit("setReady", false);
            if(data.userId){
                let user = await romeApi.get(`/user/${data.userId}`);
                user.roles = getRoles(user.roles);
                commit("setUser", user);
            } else {
                commit("clearUser");
            }
            commit("setReady", true);
        },
        async clear({commit}) {
            commit("setUser", null);
        },
    },
    mutations: {
        setReady(state, value) {
            state.ready = value;
        },
        setUser(state, user) {
            utils.copyCommonProperties(user, state);
        },
        clearUser(state) {
            utils.resetStoreStateProperties(state);
            state.frontLinePX = false;
        },
    }
};

function getRoles(roles) {
    return roles.map(x => {
            return { name: getUserLabelName(x), id: x }
        });
}
function getUserLabelName(id) {
    let label = userRoles.find(x => x.id == id)
    return label ? label.name : "";
}

export default store;



// WEBPACK FOOTER //
// ./src/user/x-user.js